<template>
  <div id="app">
    <!-- preloader -->
    <PreLoader ref="preLoader"/>
    <!-- preloader -->
    <router-view :togglePreLoader="togglePreLoader" />
  </div>
</template>

<script>
  import PreLoader from "@/components/Preloader"

  export default {
    components:{
      PreLoader,
    },
    methods:{
      togglePreLoader(flag){
        // console.log(flag)
        this.$refs.preLoader.togglePreLoader(flag)
      }
    },
    async mounted() {
      try {
        this.togglePreLoader("open")
        await this.$store.dispatch('cart/init');
        // console.log(this.$store.state.cart.items)
        this.togglePreLoader("close")
      }
      catch (e){
        console.log(e)
      }
    }
  }
</script>
